module.exports = __webpack_public_path__ + "img/samsung-t585-galaxy-tab-a-101.ca0eb749.png";